<template>
  <tr
    class="clickable"
    @click="goToYacht(yacht.id)"
  >
    <td>
      <strong>{{ yacht.id }}</strong>
    </td>
    <td>
      <div
        v-if="!yacht.name"
        class="grey--text text--lighten-1"
      >
        No Name
      </div>
      <div v-else>
        {{ yacht.name }}
      </div>
    </td>
    <td class="text-no-wrap">
      <div
        v-if="!yacht.model.full_label"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div
        v-else
        style="max-width: 150px; text-overflow: ellipsis; overflow: hidden"
      >
        {{ yacht.model.label }}
        <div class="font-weight-light grey--text text--darken-2">
          {{ yacht.model.manufacturer.name }} &middot; #{{ yacht.model.id }}
        </div>
      </div>
    </td>
    <td>
      <div
        v-if="!yacht.ex_factory_date"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ yacht.ex_factory_date | moment('D MMM YYYY') }}
      </div>
    </td>
    <td class="text-no-wrap">
      <div
        v-if="yacht.country"
        style="max-width: 110px"
        class="text-truncate"
      >
        <flag
          v-if="yacht.country"
          :iso="yacht.country.code"
          class="mr-1"
          :squared="false"
        />
        <span
          v-if="yacht.destination_base"
        >
          {{ yacht.destination_base.name }}
        </span>
      </div>
      <div
        v-else
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
    </td>
    <td class="px-0">
      <v-chip
        small
        :color="investmentStatusData[yacht.investment_status].color"
        text-color="white"
        class="ma-0 caption"
      >
        {{ investmentStatusData[yacht.investment_status].label }}
      </v-chip>
    </td>
    <td class="pl-2 pr-0">
      <v-chip
        small
        :color="statusData[yacht.status].color"
        text-color="white"
        class="ma-0 caption"
      >
        {{ statusData[yacht.status].label }}
      </v-chip>
    </td>
    <td>
      <div
        v-if="!yacht.finance_model"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ yacht.finance_model.label }}
      </div>
    </td>
    <td
      v-if="$can('view', 'Owner')"
    >
      <div
        v-if="!yacht.owner"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ yacht.owner.name }}
      </div>
    </td>
    <td
      v-if="$can('view-sale-price', 'Yacht')"
      class="text-no-wrap"
    >
      <strong>{{ yacht.total_sale_price | currency(yacht.currency) }}</strong>
    </td>
    <td v-if="showSalesRep">
      <div
        v-if="!yacht.sales_rep"
        class="grey--text text--lighten-1"
      >
        N/A
      </div>
      <div v-else>
        {{ yacht.sales_rep.name }}
      </div>
    </td>
  </tr>
</template>

<script>
import Yacht from '@/models/Yacht'

export default {
    name: 'SalesRow',
    props: {
      yacht: {
        type: Object,
        default: null
      },
      showLogistics: {
        type: Boolean,
        default: false
      },
      showSalesRep: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        statusData: Yacht.statusData,
        investmentStatusData: Yacht.investmentStatusData
      }
    },
    methods: {
      goToYacht(yachtId) {
        let route = this.$router.resolve({ name: 'yachtDashboard', params: { id: yachtId } })

        window.open(route.href, '_blank')
      }
    }
  }
</script>

<style scoped>

</style>
